<template>
  <div class="customer-filter">
    <el-form :inline="true">
      <el-form-item label="商家">
        <tenantSelector
          size="small"
          ref="tenantSelector"
          v-model="searchForm.tenant"
        />
      </el-form-item>
      <el-form-item label="">
        <dateOptionSelector
          size="small"
          v-model="searchForm.dateTime"
          ref="dateOptionSelector"
          :options="dateOptions"
        />
      </el-form-item>
      
      <el-form-item label="关键词">
        <el-input
          size="small"
          v-model="searchForm.search"
          style="width: 200px"
          placeholder="单号/姓名/电话/地址/备注.."
        ></el-input>
      </el-form-item>
      <el-form-item>
        <slot></slot>
      </el-form-item>
    </el-form>
  </div>
</template>
    <script>
import dateOptionSelector from "@/components/dateOptionSelector";
import enumSelector from "@/components/enumSelector";
import tenantSelector from "@/components/tenantSelector";
export default {
  components: {
    enumSelector,
    dateOptionSelector,
    tenantSelector,
  },
  props: {
    star: {
      default: 0,
    },
  },
  watch: {
    star: {
      handler(val) {
        this.searchForm.star = val;
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      dateOptions: [
        { value: "comment", name: "评价时间" },
        { value: "insert", name: "下载时间" },
      ],
      searchForm: {
        search: "",
        tenant: "",
        star: "",
        dateTime: {
          dateType: "comment",
          date: [],
        },
      },
    };
  },
  methods: {
    getfilter() {
      let filters = {
        tenant: this.searchForm.tenant ? this.searchForm.tenant.Key : "",
        search: this.searchForm.search,
        star: this.searchForm.star,
        dateType: this.searchForm.dateTime.dateType,
        beginDate:
          this.searchForm.dateTime.date.length > 0
            ? this.searchForm.dateTime.date[0]
            : "",
        endDate:
          this.searchForm.dateTime.date.length > 1
            ? this.searchForm.dateTime.date[1]
            : "",
      };
      return filters;
    },
  },
  mounted() {},
};
</script>
    <style lang='scss' scoped>
/deep/.el-form-item {
  margin-bottom: 10px;
}
</style>